<template>
  <div class="detra-modal" v-show="show">
    <div class="dm-holder" :class="[_with_sidebar]">
      <div class="dm-body">
        <slot></slot>
      </div>
      <div class="dm-sidebar" v-if="sidebar">
        <slot name="sidebar"></slot>
      </div>

      <div class="dm-close-button-holder">
        <slot name="close-button-content"></slot>
        <div class="dm-close-button" @click="hide()">
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>
    <div class="dm-backdrop" @click="hide()"></div>
  </div>
</template>
<script>
export default {
  props: {
    show: {
      default: false,
    },
    sidebar: {
      default: false,
    }
  },
  created() {
    document.addEventListener('keyup', e => e.key === "Escape" && this.show && this.hide())
  },
  computed: {
    _with_sidebar() {
      return this.sidebar ? 'with-sidebar' : null
    }
  },
  methods: {
    hide() {
      this.$emit('hide')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/detra-modal.vue